import React from "react";
import "./stats-section.m.css";
import PeopleIcon from "../../../../assets/icons/people-icon";
import BuildingIcon from "../../../../assets/icons/building-icon";
import AwardIcon from "../../../../assets/icons/award-icon";
import NetworkIcon from "../../../../assets/icons/network-icon";

const StatsSection = () => {
  const statsData = [
    {
      id: 1,
      highlight: "30+ years",
      text: " of independent leadership intelligence",
      icon: <AwardIcon />
    },
    {
      id: 2,
      highlight: "70% NSE 50",
      text: " represented across IMA membership",
      icon: <NetworkIcon />
    },
    {
      id: 3,
      highlight: "2500+ CXOs",
      text: " actively driving dialogue",
      icon: <PeopleIcon />
    },
    {
      id: 4,
      highlight: "1500 companies",
      text: " from across all major sectors",
      icon: <BuildingIcon /> 
    }
  ];

  return (
    <div styleName="stats-section">
      <div styleName="stats-container">
        {statsData.map((stat) => (
          <div key={stat.id} styleName="stat-card">
            <div styleName="text-content">
              <p styleName="stat-text">
                <span styleName="highlight">{stat.highlight}</span>
                {stat.text}
              </p>
            </div>
            <div styleName="stats-icon">{stat.icon}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export { StatsSection };